
export const call_center_operator   = 'call_center_operator';
export const status_independent     = 'status_independent';
